import React from 'react';
import type { ProcedureType } from '../../../../../../services/EncounterService/types/encounterTypes';

/**
 * Formats a datetime string for display
 */
export const formatDateTime = (dateTimeString?: string): string => {
  if (!dateTimeString) return 'N/A';
  
  try {
    const date = new Date(dateTimeString);
    return date.toLocaleString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  } catch {
    return 'N/A';
  }
};

/**
 * Formats duration for display
 */
export const formatDuration = (duration?: number, units?: string): string => {
  if (!duration) return 'N/A';
  return `${duration} ${units || 'min'}`;
};

interface DateTimeDisplayProps {
  dateTime?: string;
}

/**
 * Display component for datetime values
 */
export const DateTimeDisplay: React.FC<DateTimeDisplayProps> = ({ dateTime }) => (
  <span>{formatDateTime(dateTime)}</span>
);

interface DurationDisplayProps {
  duration?: number;
  units?: string;
}

/**
 * Display component for duration values
 */
export const DurationDisplay: React.FC<DurationDisplayProps> = ({ duration, units }) => (
  <span>{formatDuration(duration, units)}</span>
);

/**
 * Grid template for procedure start time
 */
export const startTimeTemplate = (props: ProcedureType) => (
  <DateTimeDisplay dateTime={props.procedureStart} />
);

/**
 * Grid template for procedure end time
 */
export const endTimeTemplate = (props: ProcedureType) => (
  <DateTimeDisplay dateTime={props.procedureEnd} />
);

/**
 * Grid template for procedure duration
 */
export const durationTemplate = (props: ProcedureType) => (
  <DurationDisplay duration={props.procedureDuration} units={props.procedureTimeUnits} />
);

export default DateTimeDisplay;
